import { Col, Row } from 'reactstrap';

/**
 * @typedef {Object} SummaryLineData
 * @property {string} lineField
 * @property {string} lineValue
 * @property {boolean} [isBold]
 */

/**
 * @typedef {Object} Props
 * @property {SummaryLineData} summaryLineData
 */

/**
 * @function InvoiceSummaryLine
 * @param {Props} props
 * @type {React.JSX.Element}
 */
const InvoiceSummaryLine = ({ summaryLineData }) => {
  return (
    <Row>
      <Col
        className={`col-3 offset-sm-7 invoiceSummaryLine ${summaryLineData.isBold ? 'invoiceBold' : ''}`}
      >{summaryLineData.lineField}</Col>
      <Col
        className={`col-2 invoiceSummaryLine ${summaryLineData.isBold ? 'invoiceBold' : ''}`}
      >{summaryLineData.lineValue}</Col>
    </Row>
  );
};

export default InvoiceSummaryLine;
